import script from "./AdmLogout.vue?vue&type=script&lang=js"
export * from "./AdmLogout.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__